import React from 'react';
import { FacilitiesHeader } from './facility-header';
import _ from 'lodash';
export var FacilitiList = React.createClass({
  getInitialState() {
    return {
      listItem: this.props.list

    }
  },
  componentWillMount() {

  },
  generateList: function () {

    var listData = this.props.data;
    var list = listData && listData.map(function (listItem, key) {

      let admin_length =  listItem.facilityUserCount.activeAdmin;
      let staff_length =  listItem.facilityUserCount.activeStaff;
      let patients_length = listItem.facilityUserCount.activePatient;

      let active_inactive = listItem.active ? "active-clinic" : "inactive-clinic"
      let class_name = admin_length ? active_inactive : active_inactive + " no_admins";
      return (<li className={class_name} key={key} data-facilit-id={listItem.id} onClick={this.props.viewAction}><div className="facility-item"><ul className="facility-item-holder"><li className="name"><div className="name-width" ><span data-facilit-id={listItem.id} className="icon icon-hospital"></span>{listItem.name}</div></li><li className="phone"><div><span className="icon icon-phone"></span>{listItem.mobile}</div></li><li className="email"><div className="name-width"><span className="icon icon-email"></span>{listItem.email}</div></li><li className="admin-detail"><div className="view-details text-center"><ul><li className="admin"><p>MOBI ADMIN</p><h4>{admin_length}</h4></li><li className="staff"><p>STAFF</p><h4>{staff_length}</h4></li><li className="patients"><p>PATIENTS</p><h4>{patients_length}</h4></li></ul></div></li><li className="add-admin">{admin_length ? listItem.active ? <button className="white-button" data-facilit-id={listItem.id} onClick={this.props.viewAction}>view</button> : <button className="gray-button" data-facilit-id={listItem.id} onClick={this.props.viewAction} >Deactivated</button> : listItem.active ? <button className="gray-button" data-facilit-id={listItem.id} onClick={this.props.add_dmin}>Add Mobi Admin</button> : <button className="gray-button" data-facilit-id={listItem.id} onClick={this.props.viewAction} >Deactivated</button>}</li></ul></div></li>)
    }, this);
    if (listData && listData.length) {
      return list;
    } else {
      return [];
    }

  },

  render() {
    return (
      <div><FacilitiesHeader activeTgCls={this.props.toggleClass} searchlist={this.props.search} addnew={this.props.addNew} tgList={this.props.toggletoList} tgGrid={this.props.toggletoGrid} />
        <div className="facility-list-grid">
          {this.generateList().length > 0 && <div className={this.props.toggleClass} id="grid">
            <ul>
              <li className="list-head">
                <ul className="facility-item-holder">
                  <li className="name">Clinic Name</li>
                  <li className="phone">Phone</li>
                  <li className="email">Email</li>
                  <li className="admin">Mobi Admin</li>
                  <li className="staff">Staff</li>
                  <li className="patients">Patients</li>
                  <li></li>
                </ul>
              </li>
              {this.generateList()}
            </ul>
          </div>}
          {this.generateList().length ? "" : <p className="text-left">No records found.</p>}
        </div>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/facilitiesScreen/facility-list.js
 **/